// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"20d84acf","98":"bc2f5077","198":"6eac9c16","260":"1ac5c11a","278":"93ab6a94","407":"c0626695","417":"11d8322f","903":"0d516d43","928":"d44170c1"}[chunkId] + ".chunk.js";
};